"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowParser = void 0;
const column_1 = require("./column");
const Token_1 = require("./Token");
const EMPTY_STRING = '';
class RowParser {
  constructor(parserOptions) {
    this.parserOptions = parserOptions;
    this.columnParser = new column_1.ColumnParser(parserOptions);
  }
  static isEmptyRow(row) {
    return row.join(EMPTY_STRING).replace(/\s+/g, EMPTY_STRING) === EMPTY_STRING;
  }
  parse(scanner) {
    const {
      parserOptions
    } = this;
    const {
      hasMoreData
    } = scanner;
    const currentScanner = scanner;
    const columns = [];
    let currentToken = this.getStartToken(currentScanner, columns);
    while (currentToken) {
      if (Token_1.Token.isTokenRowDelimiter(currentToken)) {
        currentScanner.advancePastToken(currentToken);
        // if ends with CR and there is more data, keep unparsed due to possible
        // coming LF in CRLF
        if (!currentScanner.hasMoreCharacters && Token_1.Token.isTokenCarriageReturn(currentToken, parserOptions) && hasMoreData) {
          return null;
        }
        currentScanner.truncateToCursor();
        return columns;
      }
      if (!this.shouldSkipColumnParse(currentScanner, currentToken, columns)) {
        const item = this.columnParser.parse(currentScanner);
        if (item === null) {
          return null;
        }
        columns.push(item);
      }
      currentToken = currentScanner.nextNonSpaceToken;
    }
    if (!hasMoreData) {
      currentScanner.truncateToCursor();
      return columns;
    }
    return null;
  }
  getStartToken(scanner, columns) {
    const currentToken = scanner.nextNonSpaceToken;
    if (currentToken !== null && Token_1.Token.isTokenDelimiter(currentToken, this.parserOptions)) {
      columns.push('');
      return scanner.nextNonSpaceToken;
    }
    return currentToken;
  }
  shouldSkipColumnParse(scanner, currentToken, columns) {
    const {
      parserOptions
    } = this;
    if (Token_1.Token.isTokenDelimiter(currentToken, parserOptions)) {
      scanner.advancePastToken(currentToken);
      // if the delimiter is at the end of a line
      const nextToken = scanner.nextCharacterToken;
      if (!scanner.hasMoreCharacters || nextToken !== null && Token_1.Token.isTokenRowDelimiter(nextToken)) {
        columns.push('');
        return true;
      }
      if (nextToken !== null && Token_1.Token.isTokenDelimiter(nextToken, parserOptions)) {
        columns.push('');
        return true;
      }
    }
    return false;
  }
}
exports.RowParser = RowParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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